import React, { useState, useEffect, useCallback } from 'react';

import { SideDiv, LastUpdatedOn } from './sideCardsStyles';
import { FlexDiv, Card } from './styles';
import { Icon, Tooltip, Spin } from 'antd';
import { getBatchDetails } from '../../utils/services/mailRoomAPI';
import { FailedDocsIcon } from '../../images/svgIcons';
import { withTranslation } from 'react-i18next';
import { FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS } from './translationValues';
import { getWeek } from '../../utils/javascript';

const NAMESPACES = ['FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS'];

const SideCards = props => {
  const { setPrintFailures, lastUpdatedOn, startAndEndDate, setDeleteDocuments, searchValue, onRefresh, dateFilterApplied, t } = props;

  const [failureCount, setFailureCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchDocumentsCount(startAndEndDate, searchValue);
  }, [fetchDocumentsCount, startAndEndDate, searchValue]);

  const fetchDocumentsCount = useCallback(
    async (startAndEndDate, searchText) => {
      try {
        setIsLoading(true);
        let payload = {
          page: 1,
          limit: 8,
          jobCreatedOnTo: startAndEndDate.endDate,
          jobCreatedOnFrom: startAndEndDate.startDate,
          printStatus: 'Failed',
          limit: 8,
        };
        if(!dateFilterApplied) {
          let startAndEndDate = getWeek();
          payload.jobCreatedOnTo = startAndEndDate.endDate;
          payload.jobCreatedOnFrom = startAndEndDate.startDate;
        }
        if (searchText) {
          payload.batchName = searchText;
        }
        const response = await getBatchDetails(payload);
        setIsLoading(false);
        if (response.hasOwnProperty('dataCount')) {
          setFailureCount(response.dataCount);
        }
      } catch (e) {
        setIsLoading(false);
      }
    },
    [startAndEndDate],
  );

  return (
    <SideDiv>
      <LastUpdatedOn>
        <p>
          {t(FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.LAST_UPDATED_ON_LABEL.key, FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.LAST_UPDATED_ON_LABEL.value)}
          {lastUpdatedOn ? <span>{lastUpdatedOn}</span> : <Icon type="loading" />}
        </p>
        <a
          onClick={() => {
            fetchDocumentsCount(startAndEndDate, searchValue);
            onRefresh();
          }}
        >
          <Icon type="reload" />
          {t(FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.REFRESH_ACTION.key, FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.REFRESH_ACTION.value)}
        </a>
      </LastUpdatedOn>
      <FlexDiv>
        <Card
          padding={'12px'}
          borderRadius={'12px'}
          height={'68px'}
          width={'148px'}
          flexDirection={'row'}
          cursorPointer={true}
          onClick={() => setPrintFailures(true)}
          className={'hoverScale'}
        >
          <div className="failureCount">
            <p> {t(FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.FAILURES_LABEL.key, FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.FAILURES_LABEL.value)}</p>
            <h3>{isLoading ? <Spin size="small" /> : failureCount}</h3>
          </div>
          <div className="failureIcon">{FailedDocsIcon()}</div>
        </Card>
        <Card
          borderRadius={'12px'}
          height={'68px'}
          width={'148px'}
          bgColor={'#ffcccb'}
          cursorPointer={true}
          className={'hoverScale'}
        >
          <div
            className="deleteDocuments"
            onClick={() => {
              setDeleteDocuments(true);
            }}
          >
            <Tooltip title={t(FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.DELETE_DOCUMENT_TOOLTIP.key, FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.DELETE_DOCUMENT_TOOLTIP.value)}>
              <Icon type="delete" />
            </Tooltip>
            <p style={{textAlign: 'center'}}>  {t(FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.DELETE_DOCUMENT_BUTTON.key, FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS.DELETE_DOCUMENT_BUTTON.value)}</p>
          </div>
        </Card>
      </FlexDiv>
    </SideDiv>
  );
};

export default withTranslation(NAMESPACES)(SideCards);
